import { DecisionTree } from "../models/decision-tree";
import { BaseDecisionTreeViewerApi } from "./base";

export class DecisionTreeApi extends BaseDecisionTreeViewerApi {
  constructor() {
    super({ model: DecisionTree, baseURL: "/decision_trees" });
  }
}

let api;

export const useDecisionTreeApi = () => {
  api ??= new DecisionTreeApi();

  return {
    find: async (id) => api.get(id.toString()),
  };
};
